import reduxFetch from 'react-redux-fetch';
import { ORGANISATION_USER_GROUPS_DETAILS_RESOURCE } from '../../constants';
import apiRoutes from '../../../../app/api/routes';

const OrganisationUserGroupsDetailsService = ComposedComponent =>
  reduxFetch([
    {
      resource: ORGANISATION_USER_GROUPS_DETAILS_RESOURCE,
      method: 'post',
      request: (organisationId, userGroupIds) => ({
        url: apiRoutes.userGroupsDetails(organisationId),
        body: userGroupIds,
      }),
    },
  ])(ComposedComponent);

export default OrganisationUserGroupsDetailsService;
